import {Box, CircularProgress, Tooltip, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import {useInfoBoxStyles} from "./InfoBoxStyles";
import {HighlightOff} from "@material-ui/icons";

const InfoBox = (props) => {
    const classes = useInfoBoxStyles(props);
    return (
        !props.loading ?
            <Tooltip title={props.value} arrow>
                <Box className={classes.infoBox}
                     onClick={!props.shouldSwitch ? props.onClick : undefined}>
                    {props.icon}
                    <Box className={classes.infoBoxName}>
                        <Typography variant="button"
                                    onClick={props.shouldSwitch ? props.onClick : undefined}
                                    className={classes.infoBoxTypography}>
                            {props.value}</Typography>

                        {props.shouldSwitch &&
                        <HighlightOff color={"inherit"} onClick={props.handleClickDelete} className={"ml-8"}/>}
                    </Box>
                </Box>
            </Tooltip> :
            <Box className={classes.infoBox}
                 onClick={props.onClick}>
                {props.icon}
                <Box className={classes.infoBoxName}>
                    <CircularProgress size={24}/>
                </Box>
            </Box>
    );
}

InfoBox.propTypes = {
    loading: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.element.isRequired,
    handleClickDelete: PropTypes.func,
    shouldSwitch: PropTypes.bool
}

InfoBox.defaultProps = {
    loading: false,
    shouldSwitch: false
}

export default InfoBox
